::ng-deep particle-version-history-dialog-view{width:100%}.pos-relative{max-height:311px}
/*# sourceMappingURL=version-history-dialog-view.component-APCBYTZJ.css.map */
